import React, { useContext, useEffect, useMemo, useState } from 'react';
import {
  TextField,
  Grid,
  FormLabel,
  FormHelperText,
  Checkbox,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  InputLabel,
  Select,
} from '@material-ui/core';
import { FormServiceContext } from 'app/utils/contexts';
import { SERVICES_CODES } from 'app/config/services';
import { useDispatch, useSelector } from 'react-redux';
import { fecthFixedGroups } from 'app/store/slices/license';

import { Field } from 'formik';
import { RadioButtonGroup, RadioButton } from 'app/components/FormElements';
import { errorHandler } from 'app/utils/errorHandler';

function AdditionalData(props) {
  const {
    errors,
    touched,
    values,
    classes,
    setFieldValue,
    oldInfo,
    oldRequest,
    oldService,
    oldLicense,
  } = props;

  const dispatch = useDispatch();
  const { canEdit } = useContext(FormServiceContext);
  const [loading, setLoading] = useState(false);

  const service = useSelector(state => state.services.details);
  const licenseFixedGroups = useSelector(state => state.license.fixedGroups);

  const fixedGroup = useMemo(() => {
    if (oldLicense?.cdTipoGrupoFixo) {
      const found = licenseFixedGroups.filter(
        g => g.cdTipoGrupoFixo === Number(oldLicense.cdTipoGrupoFixo)
      );
      if (found && found.length > 0) {
        return found[0].deTipoGrupoFixo;
      }
    }
    return '';
  }, [licenseFixedGroups, oldLicense]);

  const canEditMeses = useMemo(() => {
    if (service.cdServico === SERVICES_CODES.LICENCA_SEGUNDA_VIA) {
      return false;
    }
    return canEdit;
  }, [canEdit, service.cdServico]);

  const cdService = useMemo(() => {
    return oldService?.cdServico
      ? oldService.cdServico
      : oldRequest?.cdServico
      ? oldRequest.cdServico
      : service.cdServico;
  }, [oldRequest, oldService, service]);

  const handleInputRGChange = e => {
    let { value } = e.target;
    value = value.replace(/[^\d.\-(x)]+/g, '');
    setFieldValue('deRgResponsavel', value);
  };

  useEffect(() => {
    setLoading(true);
    const init = async () => {
      try {
        const promises = [];
        if (licenseFixedGroups.length === 0) {
          promises.push(dispatch(fecthFixedGroups()));
        }
        await Promise.all(promises);
      } catch (error) {
        errorHandler(error.response?.status, error.response?.data?.message);
      }
      setLoading(false);
    };
    init();
  }, [dispatch, licenseFixedGroups]);

  if (oldInfo) {
    //readonly
    return (
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <h3 className={classes.title}>Dados complementares</h3>
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl component="fieldset">
            <FormLabel component="legend">Nº meses solicitados</FormLabel>
            <RadioGroup
              aria-label="nuMesesOld"
              name="nuMesesOld"
              value={String(oldLicense.nuMeses || '')}
            >
              <FormControlLabel disabled value="6" control={<Radio />} label="Até 6 meses" />
              <FormControlLabel
                disabled
                value="12"
                control={<Radio />}
                label="De 6 meses a 1 ano"
              />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormLabel component="legend" style={{ marginBottom: '10px' }}>
            Periodicidade
          </FormLabel>
          <Grid container spacing={1}>
            <Grid item sm={4}>
              <label>
                <Checkbox checked={oldLicense.boMatutino} disabled name="boMatutinoOld" /> Matutino
              </label>
            </Grid>
            <Grid item sm={4}>
              <label>
                <Checkbox checked={oldLicense.boVespertino} disabled name="boVespertinoOld" />{' '}
                Vespertino
              </label>
            </Grid>
            <Grid item sm={4}>
              <label>
                <Checkbox checked={oldLicense.boNoturno} disabled name="boNoturnoOld" /> Noturno
              </label>
            </Grid>
          </Grid>
        </Grid>
        {oldRequest.cdServico === SERVICES_CODES.LICENCA_FRETAMENTO_TRATAMENTO_SAUDE && (
          <>
            <Grid item xs={12} sm={6}>
              <TextField
                name="deResponsavelOld"
                label="Nome completo do responsável pela assinatura da lista"
                value={oldLicense.deResponsavel}
                margin="dense"
                disabled
                variant="filled"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="deRgResponsavelOld"
                label="Nº de R.G. do responsável pela assinatura da lista"
                value={oldLicense.deRgResponsavel}
                margin="dense"
                disabled
                variant="filled"
                fullWidth
              />
            </Grid>
          </>
        )}
        {oldRequest.cdServico === SERVICES_CODES.LICENCA_FRETAMENTO_UNIVERSITARIOS && (
          <Grid item xs={12}>
            <TextField
              name=""
              label="Grupo Fixo"
              value={fixedGroup}
              margin="dense"
              disabled
              variant="filled"
              fullWidth
            />
          </Grid>
        )}
      </Grid>
    );
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <h3 className={classes.title}>Dados complementares</h3>
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormLabel component="legend">Nº meses solicitados</FormLabel>
        <RadioButtonGroup
          id="nuMeses"
          label=""
          value={
            service.cdServico === SERVICES_CODES.LICENCA_SEGUNDA_VIA
              ? String(oldLicense?.nuMeses || '')
              : String(values.nuMeses || '')
          }
          error={errors.nuMeses}
          touched={touched.nuMeses}
          className={classes.radioGroup}
          style={(touched.nuMeses && errors.nuMeses) ? { border: '1px solid #b71c1c' } : {}}
        >
          <Grid item sm={6}>
            <Field
              component={RadioButton}
              name="nuMeses"
              id="6"
              label="Até 6 meses"
              disabled={!canEditMeses}
            />
          </Grid>
          <Grid item sm={6}>
            <Field
              component={RadioButton}
              name="nuMeses"
              id="12"
              label="De 6 meses a 1 ano"
              disabled={!canEditMeses}
            />
          </Grid>
        </RadioButtonGroup>
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormLabel component="legend" style={{ marginBottom: '4px' }}>
          Periodicidade
        </FormLabel>
        <Grid container spacing={1}>
          <Grid container style={touched.frequencyTest && errors.frequencyTest ? { border: '1px solid #b71c1c' } : {}}>
            <Grid item sm={4}>
              <label>
                <Field
                  as={Checkbox}
                  color="primary"
                  checked={values.boMatutino}
                  disabled={!canEdit}
                  name="boMatutino"
                />{' '}
                Matutino
              </label>
            </Grid>
            <Grid item sm={4}>
              <label>
                <Field
                  as={Checkbox}
                  color="primary"
                  checked={values.boVespertino}
                  disabled={!canEdit}
                  name="boVespertino"
                />{' '}
                Vespertino
              </label>
            </Grid>
            <Grid item sm={4}>
              <label>
                <Field
                  as={Checkbox}
                  color="primary"
                  checked={values.boNoturno}
                  disabled={!canEdit}
                  name="boNoturno"
                />{' '}
                Noturno
              </label>
            </Grid>
          </Grid>
          {!!errors.frequencyTest &&
          canEdit &&
          (touched.boMatutino || touched.boVespertino || touched.boNoturno) ? (
            <FormHelperText error>{errors.frequencyTest}</FormHelperText>
          ) : null}
        </Grid>
      </Grid>
      {cdService === SERVICES_CODES.LICENCA_FRETAMENTO_TRATAMENTO_SAUDE && (
        <>
          <Grid item xs={12} sm={6}>
            <Field
              name="deResponsavel"
              label="Nome completo do responsável pela assinatura da lista"
              margin="dense"
              disabled={!canEdit}
              variant="filled"
              fullWidth
              error={!!errors.deResponsavel && canEdit && touched.deResponsavel}
              helperText={
                errors.deResponsavel && canEdit && touched.deResponsavel ? errors.deResponsavel : ''
              }
              as={TextField}
              inputProps={{
                maxLength: 100,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field
              name="deRgResponsavel"
              label="Nº de R.G. do responsável pela assinatura da lista"
              margin="dense"
              disabled={!canEdit}
              variant="filled"
              fullWidth
              error={!!errors.deRgResponsavel && canEdit && touched.deRgResponsavel}
              helperText={
                errors.deRgResponsavel && canEdit && touched.deRgResponsavel
                  ? errors.deRgResponsavel
                  : ''
              }
              as={TextField}
              onChange={e => handleInputRGChange(e)}
              inputProps={{
                maxLength: 15,
              }}
            />
          </Grid>
        </>
      )}
      {cdService === SERVICES_CODES.LICENCA_FRETAMENTO_UNIVERSITARIOS && (
        <>
          {!loading && (
            <Grid item xs={12}>
              <FormControl
                variant="filled"
                margin="dense"
                fullWidth
                disabled={!canEdit}
                error={!!errors.cdTipoGrupoFixo && canEdit && touched.cdTipoGrupoFixo}
              >
                <InputLabel htmlFor="cdTipoGrupoFixo" shrink={true}>
                  Grupo Fixo*
                </InputLabel>
                <Field
                  name="cdTipoGrupoFixo"
                  id="cdTipoGrupoFixo"
                  disabled={!canEdit}
                  as={Select}
                  validate={value => {
                    if (!value) {
                      return 'Campo obrigatório';
                    }
                  }}
                >
                  <option aria-label="None" value="">
                    Selecione
                  </option>
                  {licenseFixedGroups.map((type, index) => {
                    return (
                      <option key={`type-${index}`} value={type.cdTipoGrupoFixo}>
                        {type.deTipoGrupoFixo}
                      </option>
                    );
                  })}
                </Field>
                {errors.cdTipoGrupoFixo && canEdit && touched.cdTipoGrupoFixo ? (
                  <FormHelperText>{errors.cdTipoGrupoFixo}</FormHelperText>
                ) : null}
              </FormControl>
            </Grid>
          )}
        </>
      )}
    </Grid>
  );
}

export default AdditionalData;
